export const DISABLED_FEATURES_EK = {
  CONNECTION_SPEED_NOTIFICATION: false,
};
